exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".price-wrapper[data-v-73f90aae]{display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap;gap:10px;-ms-flex-align:center;align-items:center;-ms-flex-pack:justify;justify-content:space-between}\n", ""]);

// exports
